import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import merge from 'lodash-es/merge';
import { TREO_APP_CONFIG } from './config.constants';
import { TreoConfig } from './layout.types';

@Injectable({
  providedIn: 'root',
})
export class TreoConfigService {
  // Private
  private _config: BehaviorSubject<TreoConfig>;

  /**
   * Constructor
   */
  constructor(@Inject(TREO_APP_CONFIG) config: any) {
    // Set the private defaults
    this._config = new BehaviorSubject(config);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter and getter for config
   */
  set config(value: TreoConfig) {
    // Merge the new config over to the current config
    const config = merge({}, this._config.getValue(), value);

    // Execute the observable
    this._config.next(config);
  }

  get config$(): Observable<TreoConfig> {
    return this._config.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resets the config to the default
   */
  reset(): void {
    // Set the config
    this._config.next(this.config);
  }
}
